// Module
var code = `<div id="internet-check">
  <div class="alert alert--danger" ng-hide="internetCheck.internetConnection">
    Internet connectivity has been lost. Retrying in {{internetCheck.retrySecondsLeft}}... <a ng-click="check(true)">Retry!</a>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/internet-check/internet-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;